// extracted by mini-css-extract-plugin
export var card = "_kv-5";
export var cardSelected = "_kv-4";
export var image = "_kv-3";
export var modal = "_kv-0";
export var modalContent = "_kv-1";
export var table = "_kv-2";